<template>
  <div>
    <div class="page-actions">
      <span>关键词： </span>
      <el-input
        placeholder="用户id、邮箱或者手机号码"
        v-model="keywords"
      ></el-input>
      <el-date-picker
        v-model="times"
        type="daterange"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
      <el-button type="primary" @click="search({ page: 1 })">搜索</el-button>
      <!-- <a :href="downloadLink" target="_blank">导出Excel</a> -->
    </div>
    <el-table :data="currencies">
      <el-table-column prop="createTime" label="时间">
        <template slot-scope="scope">
          {{ scope.row.createTime | moment }}
        </template>
      </el-table-column>
      <el-table-column prop="userId" label="用户ID"></el-table-column>
      <el-table-column prop="loginIp" label="登录IP"></el-table-column>
      <el-table-column prop="loginType" label="登录方式"></el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import qs from 'qs';
import Pagination from 'components/pagination';

export default {
  name: 'loginLog',
  data() {
    return {
      times: [],
      keywords: ''
    };
  },

  computed: {
    ...mapState('loginLog', ['currencies', 'pagination', 'totalCount']),
    startTime() {
      return this.times ? this.times[0] : '';
    },
    endTime() {
      return this.times ? this.times[1] : '';
    }
    // downloadLink() {
    //     const data = {
    //     startTime:this.startTime,
    //     endTime:this.endTime,
    //     status:1,
    //     ...this.pagination
    //     };
    //     const params = qs.stringify(data);
    //     return `/la/admin/statistics/user?${params}`;
    // }
  },
  methods: {
    ...mapActions('loginLog', ['list']),
    ...mapMutations('loginLog', ['setpage']),
    search(data) {
      this.list({
        from: this.startTime,
        to: this.endTime,
        keywords: this.keywords,
        ...this.pagination,
        ...data
      });
    },
    pageChanged(pagination) {
      this.setpage(pagination);
      this.$emit('refresh', pagination);
    }
  },
  components: {
    Pagination
  }
};
</script>

<style lang="less" scoped></style>
